import { render, staticRenderFns } from "./FeatureCardVehicle.vue?vue&type=template&id=673966d5&scoped=true&"
import script from "./FeatureCardVehicle.vue?vue&type=script&lang=js&"
export * from "./FeatureCardVehicle.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCardVehicle.vue?vue&type=style&index=0&id=673966d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673966d5",
  null
  
)

export default component.exports